var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFarmersFillQuestionnaire = function SvgFarmersFillQuestionnaire(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21.9707H17.5C18.8807 21.9707 20 20.8514 20 19.4707V9.34237C20 8.54672 19.6839 7.78366 19.1213 7.22105L16.7497 4.84938C16.187 4.28677 15.424 3.9707 14.6283 3.9707H7.5C6.11929 3.9707 5 5.08999 5 6.4707V19.9707C5 21.0753 5.89543 21.9707 7 21.9707Z",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9764 8.97052H16.5C15.6716 8.97052 15 8.29895 15 7.47052V3.99414",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.9707H11",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.7242L14.6635 17.322L16 16.1191",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.9707H11",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.7244L14.6638 13.3225L16 12.1191",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFarmersFillQuestionnaire, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDIxLjk3MDdIMTcuNUMxOC44ODA3IDIxLjk3MDcgMjAgMjAuODUxNCAyMCAxOS40NzA3VjkuMzQyMzdDMjAgOC41NDY3MiAxOS42ODM5IDcuNzgzNjYgMTkuMTIxMyA3LjIyMTA1TDE2Ljc0OTcgNC44NDkzOEMxNi4xODcgNC4yODY3NyAxNS40MjQgMy45NzA3IDE0LjYyODMgMy45NzA3SDcuNUM2LjExOTI5IDMuOTcwNyA1IDUuMDg5OTkgNSA2LjQ3MDdWMTkuOTcwN0M1IDIxLjA3NTMgNS44OTU0MyAyMS45NzA3IDcgMjEuOTcwN1oiIHN0cm9rZT0iIzcxNTRENiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuOTc2NCA4Ljk3MDUySDE2LjVDMTUuNjcxNiA4Ljk3MDUyIDE1IDguMjk4OTUgMTUgNy40NzA1MlYzLjk5NDE0IiBzdHJva2U9IiM3MTU0RDYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgMTYuOTcwN0gxMSIgc3Ryb2tlPSIjNzE1NEQ2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNCAxNi43MjQyTDE0LjY2MzUgMTcuMzIyTDE2IDE2LjExOTEiIHN0cm9rZT0iIzcxNTRENiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxMi45NzA3SDExIiBzdHJva2U9IiM3MTU0RDYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDEyLjcyNDRMMTQuNjYzOCAxMy4zMjI1TDE2IDEyLjExOTEiIHN0cm9rZT0iIzcxNTRENiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };